import React from 'react';
import { cn } from '../../../../lib/utils';

/**
 * Fast Turnaround Panel Component
 * Handles fast turnaround selection with clean visual design
 */
const FastTurnaroundPanel = ({ value, options, onChange }) => {
  const handleChange = (optionValue) => {
    onChange(optionValue);
  };

  // Get color classes for each option
  const getColorClasses = (optionValue, isSelected) => {
    const colorMap = {
      Yes: {
        border: isSelected ? 'border-accent' : 'border-glass-border',
        bg: isSelected ? 'bg-accent-muted' : 'bg-surface-0',
        text: isSelected ? 'text-accent' : 'text-text-primary',
        radio: 'text-accent',
      },
      No: {
        border: isSelected ? 'border-gray-400' : 'border-glass-border',
        bg: isSelected ? 'bg-gray-400/10' : 'bg-surface-0',
        text: isSelected ? 'text-gray-400' : 'text-text-primary',
        radio: 'text-gray-400',
      },
      Sometimes: {
        border: isSelected ? 'border-gray-400' : 'border-glass-border',
        bg: isSelected ? 'bg-gray-400/10' : 'bg-surface-0',
        text: isSelected ? 'text-gray-400' : 'text-text-primary',
        radio: 'text-gray-400',
      },
    };
    return colorMap[optionValue] || {
      border: 'border-glass-border',
      bg: 'bg-surface-0',
      text: 'text-text-secondary',
      radio: 'text-text-secondary',
    };
  };

  return (
    <div>
      <div className="flex flex-col gap-1">
        {options.map((option) => {
          const isSelected = value === option.value;
          const colors = getColorClasses(option.value, isSelected);

          return (
            <button
              key={option.value}
              onClick={() => handleChange(option.value)}
              className={cn(
                'flex items-center gap-2 w-full px-2 py-1.5 sm:py-1.5 min-h-[44px] sm:min-h-0 border text-left',
                colors.border,
                colors.bg
              )}
            >
              <div className={cn(
                'w-4 h-4 border-2 flex items-center justify-center flex-shrink-0',
                isSelected ? colors.radio : 'border-text-tertiary'
              )}>
                {isSelected && (
                  <div className={cn('w-2 h-2', {
                    'bg-accent': option.value === 'Yes',
                    'bg-gray-400': option.value === 'No',
                    'bg-gray-400': option.value === 'Sometimes',
                  })} />
                )}
              </div>
              <span className={cn(
                'text-[0.813rem]',
                isSelected ? 'font-semibold' : 'font-normal',
                colors.text
              )}>
                {option.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FastTurnaroundPanel;
